import { toast } from "sonner";

/**
 * Show a gold-styled toast after a confirmed booking.
 * Call: showPointsEarnedToast(150)
 */
export function showPointsEarnedToast(points: number) {
  toast(`🎉 You earned ${points.toLocaleString()} Flexaura Points on this booking!`, {
    duration: 4000,
    position: "bottom-right",
    style: {
      background: "hsl(211 62% 13%)",
      color: "hsl(40 55% 51%)",
      border: "1px solid hsl(40 55% 51% / 0.3)",
      fontFamily: "'DM Mono', monospace",
    },
  });
}
